import React from 'react';
import { Check } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { Button } from 'ui';

const FeedbackSubmissionSuccess = ({ inline, resetStateAndClose }) => {
  return (
    <>
      {inline ? (
        <div className="d-f fd-c pt-12">
          <Text
            className="d-f ai-c c-success"
            variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}
          >
            <Check size="2rem" className="mr-4" />
            {t(
              'practice.on_demand_practice.audio_recording.skip_recording.success.success_short',
            )}
          </Text>
        </div>
      ) : (
        <div className="d-f fd-c">
          <Text
            className="d-f ai-c c-success"
            variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}
          >
            <Check size="2rem" className="mr-4" />
            {t(
              'practice.on_demand_practice.audio_recording.skip_recording.success.success_short',
            )}
          </Text>
          <Button
            type="button"
            className="mt-30 as-fe"
            onClick={() => resetStateAndClose()}
          >
            {t('common.close')}
          </Button>
        </div>
      )}
    </>
  );
};

export default FeedbackSubmissionSuccess;
